/* eslint-disable no-useless-escape */
export const EMAIL_REGEXP = /^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/
/* eslint-enable no-useless-escape */

export const PHONE_REGEXP = /^\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
export const URL_REGEXP = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,256}\b([-a-zA-Z0-9@:%_.~#?&//=]*)/
export const IP_URL_REGEXP = /^https?:\/\/(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(:()([1-9]|[1-5]?[0-9]{2,4}|6[1-4][0-9]{3}|65[1-4][0-9]{2}|655[1-2][0-9]|6553[1-5]))?\b([-a-zA-Z0-9@%_.~#?&//=]*)$/



// WEBPACK FOOTER //
// ./src/validation/constants.js